
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDButton from "components/MDButton";
import { Select, MenuItem, FormControl, Box } from '@mui/material';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import EditIcon from '@mui/icons-material/Edit';
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { CircularProgress, Backdrop, Tooltip, tooltipClasses } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import DoneIcon from '@mui/icons-material/Done';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from 'react-router-dom';
import { handleErrors, checkPrivilege, convertToTree, manipulateDataForDefaultSelected, getProductImage } from "common.js";
import { PRODUCT, PRIVILEGE,PAGINATIONSIZE } from "constants.js";
import TreeSelect from "components/TreeSelect";
import configurationContext from "contextConfig";
import { useMaterialUIController, setProductContext } from "context";
import DeleteConfirmation from "layouts/components/DeleteConfirmation.js";
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import { styled } from '@mui/material/styles';

function ManageProducts() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [productData, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");
  const [collections, setCollections] = useState([]);
  const [collectionId, setCollectionId] = useState([]);
  const [responseResultCount, setResponseResultCount] = useState(0);
  const MyContext = useContext(configurationContext);
  const [controller, dispatch, initialState] = useMaterialUIController();
  const { productContext } = controller;
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [isProductContextChanged, setProductContextChanged] = useState(false);

  var pageSelected = 1;
  const { pageNo } = useParams();

  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }

  const handleResetFilters = () => {
    setProductContext(dispatch, initialState.productContext);
    setProductContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/products/manage/page-1");
    else
      navigate("/products/manage");
  };

  // Effect to check for changes in productContext
  useEffect(() => {
    const hasChanged = Object.keys(productContext).some(
      key => productContext[key] !== initialState.productContext[key]
    );
    setProductContextChanged(hasChanged);
  }, [productContext]);

  const changeStatus = async (id, status) => {
    setIsLoading(true);
    axios({
      url: (status == 5) ? BASE + "api/product/remove/" + id : BASE + "api/product/updateStatus/" + id + "/" + status,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY,
        function: Config.FUNCTION_KEY
      },
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const message = response.data.message;
        if (response.data.status == 1) {
          if (productData.data.rows) {
            const tempNewRows = productData.data.rows;
            for (const key2 in tempNewRows) {
              if (tempNewRows[key2]['id'] == id) {
                setData(prevState => {
                  const updatedProductStatus = prevState.data.rows.map(item => {
                    if (item.id === id) {
                      return { ...item, status: status };
                    }
                    return item;
                  })
                  return {
                    ...prevState,
                    data: {
                      ...prevState.data,
                      rows: updatedProductStatus
                    }
                  };
                });
              }
            }
          }
          toast.success(t(response.data.message));
        }
        else {
          toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch((error) => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const data = () => {
    setIsLoading(true);
    axios({
      url: BASE + "api/product/list?paginationSize="+PAGINATIONSIZE.MANAGE_PRODUCT+"&pageSelected=" + pageSelected + "&statusFilter=" + productContext.statusFilter + "&orderBy=" + productContext.orderBy + "&orderValue=" + productContext.orderValue + "&searchBy=" + productContext.searchBy + "&searchValue=" + productContext.searchValue + "&collectionId=" + productContext.collectionId + "&dataFrom=products",
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    })
      .then(function (response) {
        setIsLoading(false)
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            setResponseResultCount(response.data.data.totalCount)
            setData(response.data);
          }
          else {
            toast.error(t(message))
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  const getHierarchy = () => {
    setIsLoading(true)
    axios({
      url: BASE + "api/collection/getHierarchy/" + 1,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    })
      .then(function (response) {
        setIsLoading(false);
        const requestStatus = response.status;
        if (requestStatus == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            const responseData = response.data.data;
            if (responseData) {
              const newObj = {
                children: [],
                collectionId: -1,
                handle: "unmappedProducts",
                id: -1,
                name: t('unmappedProducts'),
                parentId: 0,
                status: 1
              };
              responseData.unshift(newObj);
              const convertedData = convertToTree(responseData);
              setCollections(convertedData);
            }
          }
          else {
            toast.error(t(message));
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  const handleSelectCollections = (selectedNode) => {
    let ids = [...collectionId];
    if (ids.includes(selectedNode.value))
      ids = ids.filter(item => item !== selectedNode.value);
    else {
      ids = [selectedNode.value];
    }
    setCollectionId(ids);
    setProductContext(dispatch, { ...productContext, collectionId: (ids.length > 0) ? ids[0] : 0 });
    manipulateDataForDefaultSelected(collections, ids);
  };

  useEffect(() => {
    data();
    getHierarchy();
  }, [pageNo]);

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      minWidth: "500px",
      maxHeight: 300,
      overflowY: 'auto',
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

  const columns = [
    { Header: t("image"), accessor: "image", align: "left" },
    { Header: t("productId"), accessor: "id", align: "left" },
    { Header: t("shopifyId"), accessor: "shopifyid", align: "left" },
    { Header: t("title"), accessor: "title", align: "left" },
    { Header: t("vendorName"), accessor: "vendorName", align: "left" },
    { Header: t("vendorShopName"), accessor: "vendorShopName", align: "left" },
    { Header: t("GSTSlab"), accessor: "gstSlab", align: "left" },
    { Header: t("status"), accessor: "status", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];

  const finalObj = [];
  for (const key in productData.data) {
    if (productData.data.hasOwnProperty(key)) {
      let dataObj = productData.data[key];
      for (const key1 in dataObj) {
        let dataRow = dataObj[key1];
        if (dataRow.id > 0) {
          let tempObj = {
            image: <MDBox component="img" src={getProductImage(dataRow.images)} className="profileThumbImage" />,
            id: '#' + dataRow.id,
            shopifyid: (dataRow.shopifyProductId > 0) ? dataRow.shopifyProductId : t('na'),
            title: ((dataRow.title).length <= 50) ? dataRow.title : <HtmlTooltip title={dataRow.title}>
              <MDTypography component="span" className="tooltipMessage" variant="body3" color="text"> {(dataRow.title).substring(0, 50)}<ReadMoreIcon className="readMoreIcon" /></MDTypography>
            </HtmlTooltip>,
            vendorName: dataRow.name,
            gstSlab   :(dataRow.gstSlab)?dataRow.gstSlab:0,
            vendorShopName: (dataRow.vendorShopName) ? dataRow.vendorShopName : '-',
            status: <span className={'statusD' + dataRow.status}>
              {(dataRow.status == PRODUCT.DRAFT) ? <span>{t('draft')}</span> : (dataRow.status == PRODUCT.ACTIVE) ? t('active') :
                (dataRow.status == PRODUCT.PENDING) ? t('pending') : (dataRow.status == PRODUCT.REJECTED) ? t('rejected') : (dataRow.status == PRODUCT.ARCHIVED) ? t('archived') : (dataRow.status == PRODUCT.DELETED) ? t('deleted') : null}</span>,
            action:
              <span className="actionLinksStyle">
                {
                  (dataRow.status != PRODUCT.DELETED) ?
                    <>
                      {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("product", "read") || checkPrivilege("product", "write")))) ?

                        <MDTypography component="a" onClick={(event) => { event.preventDefault(); navigate("/products/edit/" + dataRow.id) }} className="mousePointer" variant="caption" color="text" fontWeight="medium">
                          <Tooltip title={t('edit')}><Box className="ActionEdit paddingRight5"><EditIcon /></Box></Tooltip>
                        </MDTypography>
                        : null
                      }
                    </>
                    : null
                }
                {
                  (dataRow.status == PRODUCT.ACTIVE) ?
                    <>
                      {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("product", "write"))) ?
                        <MDTypography component="a" href={"#"} onClick={() => changeStatus(dataRow.id, 4)}>
                          <Tooltip title={t('archive')}><Box className="ActionArchieve paddingRight5"><ArchiveIcon /></Box></Tooltip>
                        </MDTypography>
                        :
                        null}
                 
                    </>
                    :
                    (dataRow.status == PRODUCT.DRAFT) ?
                      <>
                        {dataRow.shopifyProductId === 0 ?
                          (adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("product", "delete"))) ?
                            <MDTypography component="a"
                              onClick={(event) => {
                                event.preventDefault();
                                setConfirmationDialogOpen(true);
                                setDeleteId(dataRow.id);
                              }}>
                              <Tooltip title={t('delete')}><Box className="ActionDelete paddingRight5"><DeleteIcon /></Box></Tooltip>
                            </MDTypography>
                            : null
                          : null
                        }
                      </>
                      :
                      (dataRow.status == PRODUCT.PENDING) ?
                        <>
                          {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("product", "write"))) ?
                            <>
                              <MDTypography component="a" onClick={() => changeStatus(dataRow.id, 1)}>
                                {(dataRow.status == PRODUCT.ARCHIVED) ?
                                  <Tooltip title={t('unarchive')}><Box className="ActionUnarchive paddingRight5"><UnarchiveIcon /></Box></Tooltip>
                                  :
                                  <Tooltip title={t('approve')}><Box className="ActionApprove paddingRight5"><DoneIcon /></Box></Tooltip>
                                }
                              </MDTypography>
                              <MDTypography component="a" onClick={() => changeStatus(dataRow.id, 3)}>
                                <Tooltip title={t('reject')}><Box className="ActionReject paddingRight5"><DoDisturbIcon /></Box></Tooltip>
                              </MDTypography>
                            </>
                            :
                            null
                          }
                          {dataRow.shopifyProductId === 0 ?
                            <>
                              {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("product", "delete"))) ?
                                <MDTypography component="a"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    setConfirmationDialogOpen(true);
                                    setDeleteId(dataRow.id);
                                  }}>
                                  <Tooltip title={t('delete')}><Box className="ActionDelete paddingRight5"><DeleteIcon /></Box></Tooltip>
                                </MDTypography>
                                :
                                null
                              }
                            </>
                            : null}
                        </>
                        :
                        (dataRow.status == PRODUCT.REJECTED) ?
                          <>
                            {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("product", "write"))) ?
                              <MDTypography component="a" onClick={() => changeStatus(dataRow.id, 1)}>
                                {(dataRow.status == PRODUCT.ARCHIVED) ?
                                  <Tooltip title={t('unarchive')}><Box className="ActionArchieve paddingRight5"><UnarchiveIcon /></Box></Tooltip>
                                  :
                                  null
                                }
                              </MDTypography>
                              :
                              null
                            }
                            {dataRow.shopifyProductId === 0 ?
                              <>
                                {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("product", "delete"))) ?
                                  <MDTypography component="a" onClick={(event) => {
                                    event.preventDefault();
                                    setConfirmationDialogOpen(true);
                                    setDeleteId(dataRow.id);
                                  }}>
                                    <Tooltip title={t('delete')}><Box className="ActionDelete paddingRight5"><DeleteIcon /></Box></Tooltip>
                                  </MDTypography>
                                  :
                                  null
                                }
                              </>
                              : null}
                          </>
                          :
                          (dataRow.status == PRODUCT.ARCHIVED) ?
                            <>
                              {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("product", "write"))) ?
                                <>
                                  <MDTypography component="a" onClick={() => changeStatus(dataRow.id, 1)}>
                                    {(dataRow.status == PRODUCT.ARCHIVED) ?
                                      <Tooltip title={t('unarchive')}><Box className="ActionUnarchive paddingRight5"><UnarchiveIcon /></Box></Tooltip>
                                      :
                                      <Tooltip title={t('approve')}><Box className="ActionApprove paddingRight5"><DoneIcon /></Box></Tooltip>
                                    }
                                  </MDTypography>

                                </>
                                : null}
                              {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("product", "delete"))) ?
                                <>
                                  {dataRow.shopifyProductId === 0 ?
                                    <MDTypography component="a"
                                      onClick={(event) => {
                                        event.preventDefault();
                                        setConfirmationDialogOpen(true);
                                        setDeleteId(dataRow.id);
                                      }}>
                                      <Tooltip title={t('delete')}><Box className="ActionDelete paddingRight5"><DeleteIcon /></Box> </Tooltip>
                                    </MDTypography>
                                    : null}
                                </>
                                : null}
                            </>
                            : null
                }
              </span>
          };
          finalObj.push(tempObj);
        }
      }
    }
  }

  const rows = finalObj;

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("Manage Products")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {(Object.keys(productData).length > 0) ?
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              <MDBox className="ManageProductTopSec" mx={2} mt={0} variant="gradient">
                <Grid container spacing={2} className="CollectionFilterBox" >
                  <Grid item xs={12} sm={2} md={2}>
                    <MDInput
                      select
                      name="statusFilter"
                      label={t('Status')}
                      value={productContext.statusFilter}
                      InputProps={{
                        classes: { root: "filterStyle" },
                      }}
                      className="ManageProductTopSecip"
                      onChange={(obj) => {
                        setProductContext(dispatch, { ...productContext, statusFilter: obj.target.value });
                      }} fullWidth
                    >
                      <MenuItem value='all'>{t('all')}</MenuItem>
                      <MenuItem value={0}>{t('draft')}</MenuItem>
                      <MenuItem value={1}>{t('approved')}</MenuItem>
                      <MenuItem value={2}>{t('approval pending')}</MenuItem>
                      <MenuItem value={3}>{t('rejected')}</MenuItem>
                      <MenuItem value={4}>{t('archived')}</MenuItem>
                    </MDInput>
                  </Grid>
                  <Grid item xs={12} sm={2} md={2} >
                    <MDInput
                      select
                      name="searchBy"
                      label={t('searchBy')}
                      value={productContext.searchBy}
                      InputProps={{
                        classes: { root: "filterStyle" },
                      }}
                      onChange={(obj) => {
                        if (obj.target.value == 'none') {
                          setProductContext(dispatch, { ...productContext, searchValue: '', searchBy: obj.target.value });
                        }
                        else
                          setProductContext(dispatch, { ...productContext, searchBy: obj.target.value });
                      }} fullWidth
                    >
                      <MenuItem value={'none'}>{t('None')}</MenuItem>
                      <MenuItem value={'id'}>{t('productId')}</MenuItem>
                      <MenuItem value={'shopifyProductId'}>{t('shopifyId')}</MenuItem>
                      <MenuItem value={'title'}>{t('title')}</MenuItem>
                      <MenuItem value={'sku'}>{t('sku')}</MenuItem>
                      <MenuItem value={'barcode'}>{t('barcode')}</MenuItem>
                      <MenuItem value={'vendorName'}>{t('vendor name')}</MenuItem>
                      <MenuItem value={'collectionId'}>{t('collections')}</MenuItem>
                    </MDInput>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} className="width100">
                    {productContext.searchBy == 'collectionId' ?
                      <TreeSelect data={collections} onSelect={handleSelectCollections} selected={collectionId} />
                      :
                      <FormControl className={'displayBlock'}>
                        <MDInput
                          key={'searchValue'}
                          value={productContext.searchValue}
                          disabled={(productContext.searchBy == 'none') ? true : false}
                          type="text" name="searchValue" label={t('searchInput')}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={(obj) => {
                            setProductContext(dispatch, { ...productContext, searchValue: obj.target.value });
                          }} fullWidth />
                      </FormControl>
                    }
                  </Grid>
                  <Grid item xs={12} sm={isProductContextChanged ? 1 : 2} md={isProductContextChanged ? 1 : 2}>
                    <MDInput
                      select
                      name="Sort By"
                      value={productContext.orderBy}
                      InputProps={{
                        classes: { root: "filterStyle" },
                      }}
                      label={t('orderBy')}
                      onChange={(obj) => {
                        setProductContext(dispatch, { ...productContext, orderBy: obj.target.value });
                      }} fullWidth
                    >
                      <MenuItem value={'id'}>{t('id')}</MenuItem>
                      <MenuItem value={'title'}>{t('title')}</MenuItem>
                    </MDInput>
                  </Grid>
                  <Grid item xs={12} sm={isProductContextChanged ? 1 : 2} md={isProductContextChanged ? 1 : 2} className="maxWidth14">
                    <MDInput
                      select
                      name="orderBy"
                      value={productContext.orderValue}
                      InputProps={{
                        classes: { root: "filterStyle" },
                      }}
                      label={t('order')}
                      onChange={(obj) => {
                        setProductContext(dispatch, { ...productContext, orderValue: obj.target.value });
                      }}
                      fullWidth
                    >
                      <MenuItem value={'DESC'}>{t('DESC')}</MenuItem>
                      <MenuItem value={'ASC'}>{t('ASC')}</MenuItem>
                    </MDInput>
                  </Grid>
                  <Grid item xs={12} sm={isProductContextChanged ? 3 : 1} md={isProductContextChanged ? 3 : 1}>
                    <FormControl className="filterSubmit">
                      <MDButton
                        onClick={() => {
                          navigate("/products/manage");
                          if (typeof pageNo === "undefined")
                            data()
                        }}
                        key="submit" type="submit" color="info" size="small" className="SubmitButton" disableRipple fullWidth>{t('Submit')}</MDButton>
                      {isProductContextChanged && (
                        <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  showTotalEntries={true}
                  responseResultCount={responseResultCount}
                  paginationSize={PAGINATIONSIZE.MANAGE_PRODUCT}
                  paginationLink={"/products/manage/page-"}
                  pageSelected={pageSelected}
                />
                <DeleteConfirmation
                  confirmationDialogOpen={confirmationDialogOpen}
                  setConfirmationDialogOpen={setConfirmationDialogOpen}
                  deleteId={deleteId}
                  changeStatus={changeStatus}
                  dataFrom="product"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        :
        null
      }
    </DashboardLayout>
  );
}

export default ManageProducts;
